import {Component, computed, input} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {NgClass} from '@angular/common';
import {ActivityState} from '@domain/activity/activity.dto';

@Component({
  selector: 'app-activity-state-badge',
  imports: [
    TranslocoDirective,
    NgClass,
  ],
  templateUrl: './activity-state-badge.component.html'
})
export class ActivityStateBadgeComponent {

  public readonly state = input.required<ActivityState | null | undefined>();
  public readonly verbose = input<boolean>(false);

  public readonly isDraft = computed(() => this.state() === ActivityState.Draft);

  public readonly badgeClass = computed(
    () => this.state() ? ActivityStateBadgeComponent.BADGE_CLASS_MAP[this.state()!] : ''
  );

  private static readonly BADGE_CLASS_MAP = {
    [ActivityState.Draft]: 'text-bg-warning',
    [ActivityState.Submitted]: 'text-bg-primary',
    [ActivityState.Published]: 'text-bg-success',
    [ActivityState.Deleting]: 'text-bg-dark',
    [ActivityState.Archived]: 'text-bg-light'
  }

}
